import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill mx-6"
};
const _hoisted_2 = {
  class: "data-table-shell"
};
const _hoisted_3 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_4 = {
  class: "data-table text-sm"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "data-table-td"
};
const _hoisted_8 = {
  class: "data-table-td"
};
const _hoisted_9 = {
  class: "data-table-td"
};
const _hoisted_10 = {
  class: "data-table-td"
};
const _hoisted_11 = {
  class: "data-table-td text-xs"
};
const _hoisted_12 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "space-y-4 p-6"
};
const _hoisted_16 = {
  class: "block"
};
const _hoisted_17 = {
  class: "block"
};
const _hoisted_18 = {
  key: 0,
  class: "block"
};
const _hoisted_19 = {
  class: "flex justify-end gap-3 border-t border-slate-200 px-6 py-4"
};
import { onMounted, reactive, ref, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import DeptSelector from '@/components/DeptSelector/index.vue';
import { disableWealthDataPermission, enableWealthDataPermission, getWealthDataPermissionPage, saveWealthDataPermission } from '@/api/wealth';
import WealthStatusBadge from '../components/WealthStatusBadge.vue';
import { cleanPayload, formatDateTime, PAGE_SIZE_OPTIONS, pagePayload, syncPageResult } from '../utils';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'index',
  setup(__props) {
    const filters = reactive({
      userId: null,
      scopeType: '',
      dept: null,
      status: ''
    });
    const pagination = reactive({
      current: 1,
      page: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const rows = ref([]);
    const loading = ref(false);
    const formVisible = ref(false);
    const form = reactive({
      userId: null,
      scopeType: 'DEPT',
      dept: null
    });
    function extractId(value) {
      if (Array.isArray(value)) {
        return extractId(value[0]);
      }
      if (value && typeof value === 'object') {
        return value.id;
      }
      return value || null;
    }
    function permissionQueryPayload() {
      return cleanPayload({
        userId: extractId(filters.userId),
        scopeType: filters.scopeType,
        deptId: extractId(filters.dept),
        status: filters.status
      });
    }
    async function loadPermissions() {
      loading.value = true;
      try {
        const result = await getWealthDataPermissionPage(pagePayload(pagination, permissionQueryPayload()));
        rows.value = result?.records || [];
        syncPageResult(pagination, result);
      } finally {
        loading.value = false;
      }
    }
    function handleSearch() {
      pagination.current = 1;
      pagination.page = 1;
      loadPermissions();
    }
    function handleReset() {
      Object.assign(filters, {
        userId: null,
        scopeType: '',
        dept: null,
        status: ''
      });
      handleSearch();
    }
    function handlePageChange(page) {
      pagination.current = page;
      pagination.page = page;
      loadPermissions();
    }
    function handleSizeChange(size) {
      pagination.size = size;
      handleSearch();
    }
    function openCreate() {
      Object.assign(form, {
        userId: null,
        scopeType: 'DEPT',
        dept: null
      });
      formVisible.value = true;
    }
    async function submit() {
      const userId = extractId(form.userId);
      const deptId = extractId(form.dept);
      if (!userId || !form.scopeType || form.scopeType === 'DEPT' && !deptId) {
        ElMessage.warning('请选择授权用户和范围');
        return;
      }
      await saveWealthDataPermission(cleanPayload({
        userId,
        scopeType: form.scopeType,
        deptId: form.scopeType === 'DEPT' ? deptId : 0
      }));
      ElMessage.success('授权已保存');
      formVisible.value = false;
      loadPermissions();
    }
    async function changeStatus(row, action) {
      try {
        await ElMessageBox.confirm(`确认${action === 'disable' ? '停用' : '启用'}该授权吗？`, '授权状态', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        });
        if (action === 'disable') await disableWealthDataPermission(row.id, {});else await enableWealthDataPermission(row.id, {});
        ElMessage.success('状态已更新');
        loadPermissions();
      } catch (error) {
        if (error !== 'cancel') console.error(error);
      }
    }
    watch(() => form.scopeType, scopeType => {
      if (scopeType !== 'DEPT') {
        form.dept = null;
      }
    });
    onMounted(loadPermissions);
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal mx-6 pt-6"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "财富数据授权"), _createElementVNode("p", {
          class: "list-page-description"
        }, "管理财富客户、合同、批次、申请、流水和统计的数据查看范围。")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: loadPermissions
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            class: "btn-primary",
            onClick: openCreate
          }, [...(_cache[10] || (_cache[10] = [_createTextVNode("新增授权", -1)]))])), [[_directive_permission, 'wealth:data-permission:manage']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_createVNode(UserSelector, {
            modelValue: filters.userId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.userId = $event),
            class: "selector-compact filter-bar-field",
            multiple: false,
            placeholder: "选择用户"
          }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: filters.scopeType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.scopeType = $event),
            placeholder: "请选择范围",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部范围",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "部门",
              value: "DEPT"
            }), _createVNode(_component_el_option, {
              label: "全租户",
              value: "TENANT"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(DeptSelector, {
            modelValue: filters.dept,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.dept = $event),
            class: "selector-compact filter-bar-field",
            multiple: false,
            placeholder: "选择部门"
          }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: filters.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "启用",
              value: "ACTIVE"
            }), _createVNode(_component_el_option, {
              label: "停用",
              value: "DISABLED"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_cache[15] || (_cache[15] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "用户ID"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "授权范围"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "部门ID"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "创建时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [...(_cache[11] || (_cache[11] = [_createElementVNode("td", {
          colspan: "6",
          class: "data-table-empty"
        }, "加载中...", -1)]))])) : rows.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [...(_cache[12] || (_cache[12] = [_createElementVNode("td", {
          colspan: "6",
          class: "data-table-empty"
        }, "暂无授权", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(rows.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_7, _toDisplayString(row.userId), 1), _createElementVNode("td", _hoisted_8, [_createVNode(WealthStatusBadge, {
            type: "scope",
            value: row.scopeType
          }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_9, _toDisplayString(row.deptId || '-'), 1), _createElementVNode("td", _hoisted_10, [_createVNode(WealthStatusBadge, {
            type: "permission",
            value: row.status
          }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(formatDateTime)(row.createTime)), 1), _createElementVNode("td", _hoisted_12, [row.status === 'ACTIVE' ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "table-action-button is-danger",
            title: "停用",
            "aria-label": "停用",
            onClick: $event => changeStatus(row, 'disable')
          }, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M18.364 18.364L5.636 5.636"
          })], -1)]))], 8, _hoisted_13)), [[_directive_permission, 'wealth:data-permission:manage']]) : _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "table-action-button is-success",
            title: "启用",
            "aria-label": "启用",
            onClick: $event => changeStatus(row, 'enable')
          }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_14)), [[_directive_permission, 'wealth:data-permission:manage']])])]);
        }), 128))])])])]), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pagination,
          "page-sizes": _unref(PAGE_SIZE_OPTIONS),
          onPageChange: handlePageChange,
          onSizeChange: handleSizeChange
        }, null, 8, ["pagination", "page-sizes"])) : _createCommentVNode("", true)]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: formVisible.value,
          size: "lg",
          scrollable: false,
          onClose: _cache[8] || (_cache[8] = $event => formVisible.value = false)
        }, {
          default: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("div", {
            class: "border-b border-slate-200 px-6 py-4"
          }, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "新增财富数据授权")], -1)), _createElementVNode("div", _hoisted_15, [_createElementVNode("label", _hoisted_16, [_cache[16] || (_cache[16] = _createElementVNode("span", {
            class: "form-label"
          }, [_createTextVNode("授权用户 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(UserSelector, {
            modelValue: form.userId,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.userId = $event),
            multiple: false,
            placeholder: "选择授权用户"
          }, null, 8, ["modelValue"])]), _createElementVNode("label", _hoisted_17, [_cache[17] || (_cache[17] = _createElementVNode("span", {
            class: "form-label"
          }, [_createTextVNode("授权范围 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: form.scopeType,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.scopeType = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "部门",
              value: "DEPT"
            }), _createVNode(_component_el_option, {
              label: "全租户",
              value: "TENANT"
            })]),
            _: 1
          }, 8, ["modelValue"])]), form.scopeType === 'DEPT' ? (_openBlock(), _createElementBlock("label", _hoisted_18, [_cache[18] || (_cache[18] = _createElementVNode("span", {
            class: "form-label"
          }, [_createTextVNode("授权部门 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(DeptSelector, {
            modelValue: form.dept,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.dept = $event),
            multiple: false,
            placeholder: "选择授权部门"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[7] || (_cache[7] = $event => formVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary",
            onClick: submit
          }, "保存")])]),
          _: 1
        }, 8, ["visible"])]))]),
        _: 1
      });
    };
  }
};